<template lang="pug">
	.product-info
		//- Product title
		h1.product-info__title(v-if="product.name") {{ product.name }}

		//- Mobile product gallery (only on tablet & mobile version)
		.product-info-gallery(v-swiper:productGallery="galleryOptions")
			//- v-viewer
			.swiper-wrapper
				.swiper-slide(v-for="(image, index) in product.images" :key="index" @click="toogleMobileZoom()")
					img.lazyload(src="/img/img-preloader.svg"
												:data-src="image.src" 
												:alt="image.alt"
												:title="image.alt")
		.product-info-thumbs(v-swiper:thumbsGallery="thumbsOptions")
			.swiper-wrapper
				.swiper-slide(v-for="(image, index) in product.images" :key="index")
					img.lazyload(src="/img/img-preloader.svg"
												:data-src="image.src" 
												:alt="image.alt"
												:title="image.alt")
			//- Optional controls
			.swiper-button-prev
				svg-icon.icon-slider-arrow(name="slider-arrow")
			.swiper-button-next
				svg-icon.icon-slider-arrow(name="slider-arrow")

		//- Mobile product gallery zoom
		transition(name="page")
			.product-info-zoom(v-show="showMobileZoom")
				.item(v-for="(image, index) in product.images" :key="index" @click="toogleMobileZoom()")
					img.lazyload(src="/img/img-preloader.svg"
												:data-src="image.src" 
												:alt="image.alt"
												:title="image.alt")

		//- Product description
		.product-info__description(v-if="product.description" v-html="product.description")

		//- Product attributes
		.product-info__attributes(v-if="product.attributes.length > 0")
			template(v-for="(attribute, index) in product.attributes")
				.attribute(v-if="attribute.name !== 'Size' && attribute.name !== 'Color'" :key="index")

					.attribute__name(v-if="attribute.name === 'Heel Height'") {{ $t('products.heelHeight') }}
					.attribute__name(v-else-if="attribute.name === 'Materials'") {{ $t('products.materials') }}
					.attribute__name(v-else-if="attribute.name === 'Occasion'") {{ $t('products.occasion') }}
					.attribute__name(v-else-if="attribute.name === 'Origin'") {{ $t('products.origin') }}
					.attribute__name(v-else) {{ attribute.name }}

					template(v-for="(option, index) in attribute.options")
						.attribute__option(:key="index") {{ option }}

		//- Color attributes
		.product-info__colors(v-if="product.attributes.length > 0")
			.title {{ $t('products.color') }}

			.color.active(v-tooltip="{ content: productColorReal[0].name }")
				i.icon
					svg-icon.icon-check(name="check")
				img.lazyload(src="/img/img-preloader.svg"
											:data-src="productColorReal[0][0]" 
											:alt="productColorReal[0].name"
											:title="productColorReal[0].name")

			.color(v-if="product.cross_sell_ids.length > 0"
							v-for="(crossSellProduct, index) in product.cross_sell_ids" :key="index")
				nuxt-link(:to="localePath({ name: 'product-slug', params: { slug: replaceUrl(crossSellProduct.link) } }) + '/'"
									v-tooltip="crossSellProduct.name")
					img.lazyload(src="/img/img-preloader.svg"
												:data-src="crossSellProduct.product_color_icon" 
												:alt="crossSellProduct.name"
												:title="crossSellProduct.name")

		//- Size attributes
		.product-info__sizes(v-if="product.product_variations.length > 0")
			.title(v-tooltip="{ content: `${$t('products.selectSize')}`, placement: 'bottom', show: showSizeTooltip, trigger: 'manual', container: '.product-info__sizes' }") {{ $t('products.size') }}
			.product-info__sizes-list
				template(v-for="(size, index) in product.product_variations")
					a.size(v-if="size.in_stock"
						href="#" :key="index"
						@click.prevent="setActiveSize(index, size), showSizeTooltip = false, disableButton = false"
						:class="{ active: activeIndex === index}"
						v-tooltip="{ content: productSizesTable(size.variation_attributes.attribute_pa_sizes.split('-')[0]) }") {{ size.variation_attributes.attribute_pa_sizes.split('-')[0] }}
					span.size.disable(v-else :key="index") {{ size.variation_attributes.attribute_pa_sizes.split('-')[0] }}

		//- Product purshase button
		.product-info__cta.product-info__buy
			template(v-if="$cookies.get('country') !== 'Country'")
				button.btn(v-if="product.product_variations.length > 0"
									@click.prevent="addToCart(product.id, selectedVariation, product.slug, product.images[0].src)"
									:disabled="disableButton")
					template(v-if="inCart === false")
						span.text {{ $t('products.addToBag') }}
						span.separator(v-if="!product.on_sale") —
						span.price(v-html="product.price_html")
					template(v-else)
						span.text {{ $t('products.addedToBag') }}
				//- button.btn.disable(v-else)
					span.text {{ $t('products.noPrice') }}
			template(v-else)
				button.btn(@click.prevent="openCountryModal()") Choose your country
		
		//- Product order free fitting button
		.product-info__cta.product-info__fitting(v-if="$cookies.get('locale') !== 'en'")
			button.btn.btn--yellow(@click.prevent="openOrderFittingModal()")
				span.text {{ $t('modals.orderFitting.title') }}
				
		//- Product menu & share links
		.product-info__more
			nuxt-link.link(:to="localePath({ name: 'slug', params: { slug: 'payment-security' } }) + '/'")
				span.link__title {{ $t('products.links.payment') }}
			nuxt-link.link(:to="localePath({ name: 'slug', params: { slug: 'shipping' } }) + '/'")
				span.link__title {{ $t('products.links.shipping') }}
				//- span.link__shipping ($15)
			nuxt-link.link(:to="localePath({ name: 'slug', params: { slug: 'return-refunds' } }) + '/'")
				span.link__title {{ $t('products.links.return') }}

			.share
				a.share__link(href="#" @click.prevent="toggleShareBlock()") + {{ $t('products.share') }}
				.share__block(v-show="shareOpen")
					SocialSharing(:url="`https://sitelle.ua/${$route.fullPath}`"
												:title="product.name"
												:description="product.description.replace('<p>','').replace('</p>','')"
												network-tag="span"
												:quote="product.description.replace('<p>','').replace('</p>','')"
												hashtags=""
												twitter-user=""
												inline-template)
						div.share__block-links
							network(network="facebook") Facebook
							network(network="twitter") Twitter
							network(network="whatsapp") WhatsApp
							network(network="viber") Viber
					a.share__block-close(href="#" @click.prevent="toggleShareBlock()")
						svg-icon.icon-close(name="close")
</template>

<script>
import _ from 'lodash'
import { mapState, mapMutations } from 'vuex'

import api from '@/api/index'

let SocialSharing = null

if (process.browser) {
  SocialSharing = require('vue-social-sharing')
}

export default {
  components: { SocialSharing },

  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      activeIndex: null,
      selectedVariation: {},

      disableButton: false,
      shareOpen: false,
      showSizeTooltip: false,
      inCart: false,

      // Mobile product gallery
      galleryOptions: {
        slidesPerView: 1,

        breakpoints: {
          575: {}
        }
      },
      productColorReal: [
        {
          name: ''
        }
      ],
      thumbsOptions: {
        slidesPerView: 3,
        spaceBetween: 5,
        touchRatio: 0.2,
        centeredSlides: true,
        slideToClickedSlide: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          575: {}
        }
      }
    }
  },

  computed: {
    ...mapState({
      showMobileZoom: state => state.showMobileZoom
    })
  },

  watch: {
    $route: function() {
      if (this.showMobileZoom) {
        this.toogleMobileZoom()
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      const productGallery = this.productGallery
      const thumbsGallery = this.thumbsGallery

      productGallery.controller.control = thumbsGallery
      thumbsGallery.controller.control = productGallery
    })

    this.productColor()
  },

  methods: {
    ...mapMutations({
      toogleMobileZoom: 'TOOGLE_MOBILE_ZOOM',
      openCountryModal: 'TOOGLE_COUNTRY_MODAL',
      openOrderFittingModal: 'TOOGLE_ORDER_FITTING_MODAL'
    }),

    productColor() {
      const findAttrs = _(this.product.attributes)
        .filter({ name: 'Color' })
        .map('attribute_data_color')
        .flatten()
        .value()

      if (findAttrs[0] !== undefined) {
        this.productColorReal = findAttrs
      }
    },

    productSizesTable(size) {
      const sizesTable = _(this.product.attributes)
        .filter({ name: 'Size' })
        .map('attribute_data_size')
        .flatten()
        .value()
      const item = _.find(sizesTable, { slug: size })

      let result = ''

      for (const key in item) {
        for (const value in item[key]) {
          if (typeof item[key] === 'object') {
            result += item[key][value] + '<br>'
          }
        }
      }

      return result
    },

    setActiveSize(index, variation) {
      this.activeIndex = index
      this.selectedVariation = variation
    },

    toggleShareBlock() {
      if (this.shareOpen) {
        this.shareOpen = false
      } else {
        this.shareOpen = true
      }
    },

    async addToCart(id, variation, slug, image) {
      this.disableButton = true

      if (this.activeIndex === null) {
        this.showSizeTooltip = true
      } else {
        this.showSizeTooltip = false

        await this.$store.dispatch('cart/ADD_PRODUCT', {
          id,
          variation,
          slug,
          image
        })

        this.disableButton = false

        this.inCart = true

        setTimeout(() => {
          this.inCart = false
        }, 2000)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.product-info {
  padding-top: 10px;

  &__title {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  &__description {
    margin-top: 10px;
    line-height: 1.3;

    @include tablet {
      max-width: 80%;
      margin: 10px auto 0;
    }

    @include mobile {
      margin-top: 35px;
    }

    @include mobile-small {
      max-width: 100%;
    }
  }

  &__delivery {
    line-height: 1.3;
    margin-top: 10px;
  }

  &__attributes {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-left: -10px;
    margin-right: -10px;

    @include tablet {
      max-width: calc(80% + 20px);
      margin: 10px auto 0;
    }

    @include mobile {
      margin: 25px auto 0;
    }

    @include mobile-small {
      max-width: none;
      margin-left: -10px;
      margin-right: -10px;
    }

    .attribute {
      flex: 0 0 100%;
      max-width: 50%;
      margin-top: 20px;
      padding-left: 10px;
      padding-right: 10px;

      &__name {
        margin-bottom: 5px;
        font-size: 10px;
        letter-spacing: 2px;
        line-height: 1.2;
        text-transform: uppercase;
      }

      &__option {
        font-weight: 600;
        line-height: 1.3;
      }
    }
  }

  &__colors,
  &__sizes {
    display: flex;
    align-items: center;

    @include tablet {
      max-width: 80%;
      margin: 0 auto;
    }

    @include mobile-small {
      max-width: 100%;
    }

    .title {
      flex: 0 0 50px;
      max-width: 50px;
      margin-right: 10px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.3px;
      line-height: 1;
      text-transform: uppercase;
      word-break: break-word;
    }
  }

  &__colors {
    margin-top: 35px;

    .color {
      flex: 0 0 20px;
      max-width: 20px;
      height: 20px;
      margin-right: 15px;
      user-select: none;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        position: relative;

        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      a {
        display: block;
      }
    }
  }

  &__sizes {
    margin-top: 20px;

    &-list {
      margin: -10px -7.5px;
    }

    .size {
      position: relative;
      padding: 10px 7.5px;
      font-weight: 500;
      line-height: 1.25;
      user-select: none;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 7.5px;
        background-color: transparent;
        height: 1px;
        width: calc(100% - 15px);
        transition: background-color 0.3s;
      }

      &:last-child {
        margin-right: 0;
      }

      &.disable {
        color: rgba($blackColor, 0.3);
        cursor: default;
      }

      &:hover,
      &.active {
        &::after {
          background-color: $blackColor;
        }

        &.disable {
          &::after {
            background-color: transparent;
          }
        }
      }
    }
  }

  &__cta {
    @include tablet {
      max-width: 80%;
      margin-left: auto;
      margin-right: auto;
    }

    @include mobile-small {
      max-width: 100%;
    }
  }

  &__buy {
    margin-top: 20px;

    @include tablet {
      margin-top: 30px;
    }

    .text {
      margin-right: 5px;
    }

    .price {
      margin-left: 5px;

      del {
        opacity: 0.6;
      }

      ins {
        text-decoration: none;
      }
    }
  }

  &__fitting {
    margin-top: 10px;
  }

  &__more {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 10px;

    @include tablet {
      max-width: 80%;
      margin: 10px auto 0;
    }

    @include mobile-small {
      max-width: 100%;
    }

    .link {
      display: block;
      margin-right: 10px;
      font-size: 12px;
      line-height: 1.45;
      font-style: italic;

      &__shipping {
        color: rgba($blackColor, 0.8);
      }
    }

    .share {
      margin-left: auto;
      font-size: 12px;
      line-height: 1.45;
      font-style: italic;

      a {
        margin: 0;
      }

      &__block {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: $whiteColor;
      }

      &__block-links {
        display: flex;
        align-items: center;

        span {
          margin-right: 10px;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

// Mobile version
.product-info-gallery {
  display: none;
  max-width: 80%;
  margin: 0 auto;

  @include tablet {
    display: block;
  }

  @include mobile-small {
    max-width: none;
    margin-left: -15px;
    margin-right: -15px;
  }
}

.product-info-thumbs {
  display: none;
  max-width: 80%;
  margin: 0 auto;

  @include tablet {
    display: block;
  }

  @include mobile-small {
    max-width: 100%;
  }

  .swiper-slide-active {
    opacity: 0.5;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    height: 30px;
    margin-top: -15px;
    background-image: none;
    outline: 0;
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    transform: rotate(180deg);
  }
}

.product-info-zoom {
  display: none;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $whiteColor;
  overflow-y: auto;

  @include tablet {
    display: block;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
